const initialState = {};

export const pointsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "POINTS": {
      console.log("PTS is::" + JSON.stringify(action));
      return {
        values: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
